import React, { useEffect } from "react";

// types
import { Origin } from "../../../../types/origins";
import { Leader } from "../../../../types/leaders";
import { Supervisor } from "../../../../types/supervisors";
import { Seller } from "../../../../types/sellers";
import { State } from "../../../../types/states";
import { Channel } from "../../../../types/channels";
import { Client } from "../../../../types/clients";
import { OperationType } from "../../../../types/operationTypes";

// components
import BusinessFiltersContent from "./BusinessFilters.content";
import BusinessFiltersPanel from "./BusinessFiltersPanel";
import { useClassicView } from "../../../../config/classicView";
import { useSessionReady } from "../../../../config/session";

interface Props {
  dateParams: any
  // Business Filters
  idSourceFilter: string;
  setIdSourceFilter: (value: string) => void;
  originsSelected: Origin[];
  leadersSelected: Leader[];
  supervisorsSelected: Supervisor[];
  sellersSelected: any[];
  statesSelected: State[];
  channelsSelected: Channel[];
  clientsSelected: Client[];
  operationTypesSelected: OperationType[];
  setOriginsSelected: (param: Origin[]) => void;
  setLeadersSelected: (param: Leader[]) => void;
  setSupervisorsSelected: (param: Supervisor[]) => void;
  setSellersSelected: (param: any[]) => void;
  setStatesSelected: (param: State[]) => void;
  setChannelsSelected: (param: Channel[]) => void;
  setClientsSelected: (param: Client[]) => void;
  setOperationTypesSelected: (param: OperationType[]) => void;

  // redux
  origins: Origin[];
  fetchingOriginsList: boolean;
  getOriginsRequest: (data: any, params: any) => Promise<void>;
  leaders: Leader[];
  fetchingLeadersList: boolean;
  getLeadersRequest: (data: any, params: any) => Promise<void>;
  supervisors: Supervisor[];
  fetchingSupervisorsList: boolean;
  getSupervisorsRequest: (data: any, params: any) => Promise<void>;
  sellers: Seller[];
  fetchingSellersList: boolean;
  getSellersRequest: (data: any, params: any) => Promise<void>;
  states: State[];
  fetchingStatesList: boolean;
  getStatesRequest: (data: any, params: any) => Promise<void>;
  channels: Channel[];
  fetchingChannelsList: boolean;
  getChannelsRequest: (data: any, params: any) => Promise<void>;
  clients: Client[];
  fetchingClientsList: boolean;
  getClientsRequest: (data: any, params: any) => Promise<void>;
  operationTypes: OperationType[];
  fetchingOperationTypesList: boolean;
  getOperationTypesRequest: (data: any, params: any) => Promise<void>;
  sendFilters: () => void;
  resetFilters: () => void;
}

export default (props: Props) => {
  const ready = useSessionReady();

  useEffect(() => {
    if (!ready) return;
    props.getOriginsRequest({}, props.dateParams);
    props.getLeadersRequest({}, props.dateParams);
    props.getSupervisorsRequest({}, props.dateParams);
    props.getSellersRequest({}, props.dateParams);
    props.getStatesRequest({}, props.dateParams);
    props.getChannelsRequest({}, props.dateParams);
    props.getClientsRequest({}, props.dateParams);
    props.getOperationTypesRequest({}, props.dateParams);
  }, [props.dateParams, ready]);

  const { classic } = useClassicView();
  const Content = classic ? BusinessFiltersContent : BusinessFiltersPanel;

  return (
    <Content
      idSourceFilter={props.idSourceFilter}
      setIdSourceFilter={props.setIdSourceFilter}
      originsSelected={props.originsSelected}
      leadersSelected={props.leadersSelected}
      supervisorsSelected={props.supervisorsSelected}
      sellersSelected={props.sellersSelected}
      statesSelected={props.statesSelected}
      channelsSelected={props.channelsSelected}
      clientsSelected={props.clientsSelected}
      operationTypesSelected={props.operationTypesSelected}
      setOriginsSelected={props.setOriginsSelected}
      setLeadersSelected={props.setLeadersSelected}
      setSupervisorsSelected={props.setSupervisorsSelected}
      setSellersSelected={props.setSellersSelected}
      setStatesSelected={props.setStatesSelected}
      setChannelsSelected={props.setChannelsSelected}
      setClientsSelected={props.setClientsSelected}
      setOperationTypesSelected={props.setOperationTypesSelected}
      //   redux
      origins={props.origins}
      fetchingOriginsList={props.fetchingOriginsList}
      leaders={props.leaders}
      fetchingLeadersList={props.fetchingLeadersList}
      supervisors={props.supervisors}
      fetchingSupervisorsList={props.fetchingSupervisorsList}
      sellers={props.sellers}
      fetchingSellersList={props.fetchingSellersList}
      states={props.states}
      fetchingStatesList={props.fetchingStatesList}
      channels={props.channels}
      fetchingChannelsList={props.fetchingChannelsList}
      clients={props.clients}
      fetchingClientsList={props.fetchingClientsList}
      operationTypes={props.operationTypes}
      fetchingOperationTypesList={props.fetchingOperationTypesList}
      sendFilters={props.sendFilters}
      resetFilters={props.resetFilters}
    />
  );
};
